import { Alert, InfoFilledIcon } from '@mr-yum/frontend-ui'
import React, { useCallback } from 'react'
import { FormattedMessage } from 'react-intl'

import { useDisclosure } from '@/hooks/useDisclosure'
import { useLoggerLegacy } from '@/hooks/useLogger'

import { SignUpSheet } from './SignUpSheet'

export const RewardsSignUpBanner = () => {
  const { logEventLegacy } = useLoggerLegacy()
  const { setOpen, isOpen, setClosed } = useDisclosure(false)

  const handleOnSignUpOpen = useCallback(() => {
    logEventLegacy(`Clicked Rewards Sign Up Banner Component`)
    setOpen()
  }, [logEventLegacy, setOpen])

  const handleOnSignUpClose = useCallback(() => {
    logEventLegacy('Closed Rewards Sign Up Banner Component')
    setClosed()
  }, [logEventLegacy, setClosed])

  return (
    <>
      <button onClick={handleOnSignUpOpen} className="w-full text-left">
        <Alert
          variant="info-subtle"
          title={
            <FormattedMessage defaultMessage="Not a member yet?" id="QusafT" />
          }
          icon={<InfoFilledIcon />}
          fullWidth
        >
          <FormattedMessage
            defaultMessage="Tap this banner and sign up to get access to Pancake Parlour's tasty deals."
            id="advxnP"
          />
        </Alert>
      </button>

      {isOpen && <SignUpSheet onClose={handleOnSignUpClose} />}
    </>
  )
}
